import React from 'react';
import { Shield, DollarSign, Users, TrendingUp, AlertTriangle, Baby, Calculator, Heart, Target } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { MobileCarousel } from '@/components/MobileCarousel';
const statsData = [{
  percentage: "40%",
  title: "No Coverage",
  description: "of Americans don't have any life insurance",
  icon: AlertTriangle,
  color: "text-red-500",
  source: "LIMRA 2023"
}, {
  percentage: "$26/month",
  title: "Monthly Cost",
  description: "average cost for a healthy 30-year-old's term policy",
  icon: DollarSign,
  color: "text-primary"
}, {
  percentage: "$754K",
  title: "Financial Impact",
  description: "average financial impact of unexpected death on family over 10 years",
  icon: TrendingUp,
  color: "text-destructive"
}, {
  percentage: "1 in 5",
  title: "Families at Risk",
  description: "families would struggle financially within 1 month if primary wage earner passed away",
  icon: Users,
  color: "text-orange-600"
}, {
  percentage: "50%",
  title: "Cost Overestimate",
  description: "of people overestimate life insurance cost by 3×",
  icon: Calculator,
  color: "text-yellow-700"
}, {
  percentage: "10-12×",
  title: "Recommended Coverage",
  description: "income is the coverage amount most experts recommend",
  icon: Target,
  color: "text-primary"
}, {
  percentage: "$270K",
  title: "Child Costs",
  description: "average cost of raising a child to age 18",
  icon: Baby,
  color: "text-blue-500"
}, {
  percentage: "149M",
  title: "Underinsured",
  description: "Americans currently lack adequate coverage",
  icon: Shield,
  color: "text-red-500"
}, {
  percentage: "#1",
  title: "Top Reason",
  description: "replace lost income and protect family's future",
  icon: Heart,
  color: "text-primary"
}];
export const LifeInsuranceInfographic = () => {
  const isMobile = useIsMobile();
  return <section className="bg-accent/20 py-[50px]">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
              Why Life Insurance <span className="text-primary">Matters</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Real numbers that show why protecting your family is essential.
            </p>
          </div>
          
          {/* Stats Grid/Carousel */}
          {isMobile ? <MobileCarousel items={statsData.map((stat, index) => {
          const IconComponent = stat.icon;
          return <div key={index} className="bg-card border border-border rounded-2xl p-6 shadow-sm" role="article" aria-label={`Statistic: ${stat.percentage} ${stat.title}`}>
                    <div className="flex items-center justify-center mb-4">
                      <div className={`p-3 rounded-lg bg-primary/10 ${stat.color}`}>
                        <IconComponent className="h-6 w-6" aria-hidden="true" aria-label={`Icon representing ${stat.title.toLowerCase()}`} />
                      </div>
                    </div>
                    
                    <div className="space-y-2 text-center">
                      <div className={`text-3xl md:text-4xl font-bold ${stat.color}`}>
                        {stat.percentage}
                      </div>
                      <h3 className="text-lg font-semibold text-foreground">
                        {stat.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {stat.description}
                        {stat.source && <span className="block text-xs text-muted-foreground/70 mt-1">
                            ({stat.source})
                          </span>}
                      </p>
                    </div>
                  </div>;
        })} ariaLabel="Life insurance statistics carousel" /> : <div className="grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
              {statsData.map((stat, index) => {
            const IconComponent = stat.icon;
            return <div key={index} className="bg-card border border-border rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105" role="article" aria-label={`Statistic: ${stat.percentage} ${stat.title}`}>
                    <div className="flex items-center justify-between mb-4">
                      <div className={`p-3 rounded-lg bg-primary/10 ${stat.color}`}>
                        <IconComponent className="h-6 w-6" aria-hidden="true" aria-label={`Icon representing ${stat.title.toLowerCase()}`} />
                      </div>
                    </div>
                    
                    <div className="space-y-2">
                      <div className={`text-3xl md:text-4xl font-bold ${stat.color}`}>
                        {stat.percentage}
                      </div>
                      <h3 className="text-lg font-semibold text-foreground">
                        {stat.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {stat.description}
                        {stat.source && <span className="block text-xs text-muted-foreground/70 mt-1">
                            ({stat.source})
                          </span>}
                      </p>
                    </div>
                  </div>;
          })}
            </div>}
        </div>
      </div>
    </section>;
};